import { createSlice } from "@reduxjs/toolkit";
import deleteMicroscopyAnnotation from "@custom/rtk-apis/microscopy/deleteAnnotation";

const initialState = {
  status: "",
  result: [],
  message: "",
  loading: false,
  error: ""
};

const deleteMicroscopyAnnotationSlice = createSlice({
  name: "deleteMicroscopyAnnotation",
  initialState,
  reducers: {
    resetStatus(state: any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteMicroscopyAnnotation.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(deleteMicroscopyAnnotation.fulfilled, (state, { payload }) => {
        console.log("Fulfilled", payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(deleteMicroscopyAnnotation.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default deleteMicroscopyAnnotationSlice.reducer;
export const { resetStatus } = deleteMicroscopyAnnotationSlice.actions;
